import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CompanyService } from '../../services/company.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Utils } from '../../util';
import { Router } from '@angular/router';
import { toast } from 'angular2-materialize';
import { Globals } from '../../globals';

@Component({
  selector: 'app-view-company',
  templateUrl: './view-company.component.html',
  styleUrls: ['./view-company.component.css']
})
export class ViewCompanyComponent implements OnInit {
  allowed: boolean = false;
  permission: any = {};

  company$: Observable<any[]>;

  constructor(
    private service: CompanyService,
    private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      console.log(groups);
      this.permission = {
        superadmin: groups[0].superadmin,
        ...this.permissionService.constructPermissionObject(groups, service.collection)
      }
      if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
      else this.allowed = true;
    });
  }

  ngOnInit() {
    this.company$ = this.service.getCompany();
  }

  onEdit(){
    this.router.navigate(['/edit_company']);
  }

  getContryInfo(key: keyof typeof Globals.COUNTRIES){
    let cy = Globals.COUNTRIES[key];
    return `${cy.code} - ${cy.name}, ${cy.clave}`
  }

}
